import React from "react"
import { Link, withRouter } from "react-router"
import { apiAuth } from "../../api"
import { messages as sharedMessages } from "../../messages"
import profileMessages from "../../messages/profile"
import settingsMessages from "../../messages/settings"
import { FormattedMessage, injectIntl } from "react-intl"
import { getAccountSettings } from "../../scripts/accountSettings"
import { getStyleTag } from "../../styles/dynamicStyles"

class UnlockAccount extends React.Component {
  state = {
    loading: false,
    done: false,
    error: false,
    user: null
  }

  componentDidMount() {
    this.confirmToken()
  }

  confirmToken = () => {
    const {
      location: {
        query: { unlock_token: token }
      }
    } = this.props
    this.setState({ loading: true })

    if (!token) {
      this.setState({
        error: true,
        loading: false
      })
      return
    }

    apiAuth("POST", `/user/unlock/${token}`)
      .then(user =>
        this.setState({
          user,
          done: true
        })
      )
      .catch(err => {
        this.setState({
          error: true,
          loading: false
        })
      })
  }

  render() {
    const { intl } = this.props
    const { error, done } = this.state
    const accountSettings = getAccountSettings(
      intl.formatMessage(settingsMessages.authenticAccountId)
    )
    const styleBodyType = accountSettings.settings.style.content || ""

    return (
      <main id="main" role="main" tabIndex={0} data-component="Login">
        {getStyleTag("form-message")}

        {styleBodyType === "default" ? (
          <div className="row small-12 columns" id="item-info">
            <div>
              <h1 className="beta mbt">
                <FormattedMessage {...profileMessages.accountUnlock} />
              </h1>
            </div>
          </div>
        ) : null}

        {styleBodyType !== "default" ? (
          <div className="title">Unlock Account</div>
        ) : null}

        <div id="item-info">
          {error && (
            <div className="form-message state-error">
              <FormattedMessage {...profileMessages.accountUnlockError} />
            </div>
          )}
          {done && (
            <div>
              <h1 className="beta mbt">
                <FormattedMessage {...profileMessages.accountUnlockSuccess} />
              </h1>
              <Link to="/login">
                <button className="button mtt" type="button">
                  <FormattedMessage {...sharedMessages.buttonLogIn} />
                </button>
              </Link>
            </div>
          )}
        </div>
      </main>
    )
  }
}

export default withRouter(injectIntl(UnlockAccount))



// WEBPACK FOOTER //
// ./webapp/components/pages/UnlockAccount.js